import { SafariReduxDropdownObject, SafariReduxSearchDefinition } from '../state/redux-generator';

export abstract class ReduxDataAccessObject {
  Dropdown: SafariReduxDropdownObject<any>;
  Search: SafariReduxSearchDefinition<any>;
}
